<template>
	<div class="mg-t-20 mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div v-if="submitted" class="row justify-content-center">
			<div class="col-md-5">
				<request-summary-component :request="form" :type="'deposit'"></request-summary-component>

				<div class="col-12 mg-t-20 text-center">
					<router-link class="btn btn-default wd-lg-200 mx-auto shadow-sm" :to="{ name: 'dashboard' }">Go Back</router-link>
				</div>
			</div>
		</div>
		<div v-else class="justify-content-center">
			<trade-cash-balance-component :currency="'GHS'" :show-add-fund="false" />
			<div class="row">
				<deposit-form-component :header-title="'Add Funds'" :deposit="form" :form="form" :deposit-class="'col-lg-4'" @perform-deposit="deposit" />
				<bank-details-component :reference="company.external_client_id" :bank-class="'col-lg-6'" />
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
	mounted() {
		this.fetchData();
	},
	data() {
		return {
			loading: false,
			submitted: false,
			holding: {},
			form: new Form({
				external_client_id: null,
				phone: null,
				email: null,
				external_custody_account_id: null,
				external_portfolio_id: null,
				account_code: null,
				amount: null,
				charges: 0,
				total_units: null,
				units: null,
				funding_channel: null,
				payment_service: null,
				payment_type: null,
				processing_no: null,
				reference: null,
				currency: 'GHS',
				type: 'deposit',
				security: 'ICAMGH-F003',
			}),
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			company: 'company',
		}),
	},
	methods: {
		deposit() {
			if (this.form.amount && this.form.payment_service) {
				this.form.post('/api/requests').then(() => {
					if (this.form.payment_service === 'paystack') {
						this.payWithPaystack();
					} else {
						this.submitted = true;
					}
				});
			}
		},
		payWithPaystack() {
			const paymentHandler = PaystackPop.setup({
				key: process.env.MIX_PAYSTACK_PUBLIC_KEY,
				email: this.form.email,
				amount: Math.round(this.form.amount * 100),
				ref: this.form.reference,
				currency: this.form.currency,
				channels: [this.form.payment_type],
				onClose: () => {
					this.verifyTransaction(this.form.reference);
					this.form.funding_channel = null;
					this.form.amount = null;
				},
				callback: ({ reference }) => {
					this.submitted = true;
					this.verifyTransaction(reference);
				},
			});

			return paymentHandler.openIframe();
		},
		getCashHolding(external_client_id) {
			const security = 'ICAMGH-F003';

			return axios.get('/api/companies/holdings', {
				params: {
					external_client_id,
					security,
				},
			});
		},
		verifyTransaction(reference) {
			axios.post('/api/transactions/verify', {
				reference,
			});
		},
		fetchData() {
			const { external_client_id} = this.company;
			const { phone, email } = this.user.client;

			axios.all([this.getCashHolding(external_client_id)]).then(
				axios.spread((holdingResponse) => {
					this.holding = holdingResponse.data.data.holding;
					this.form.external_portfolio_id = this.holding.external_portfolio_id;
					this.form.external_client_id = external_client_id;
					this.form.phone = phone;
					this.form.email = email
					this.form.external_custody_account_id = this.holding.external_custody_account_id;
				})
			);
		},
	},
};
</script>

<style>
</style>